import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — decor: a small tabletop vase (~0.35 m tall) holding
// three thin flower stems topped with small coloured heads.
const VASE = "#8a9aa8";
const STEM = "#5f8f4e";
const HEAD_A = "#a05a40";
const HEAD_B = "#e8e4dc";
const HEAD_C = "#d4a94e";

export const flowerVase = defineModel({
  id: "flower-vase",
  batchId: "modern",
  name: "Flower vase",
  tags: ["modern", "interior", "decor", "plant", "flowers", "vase"],
  summary: "A small vase with three flower stems.",
  tiles: { w: 1, h: 1 },
  footprint: 0.4,
  parts(): Part[] {
    return [
      // tapered ceramic vase
      { geometry: new THREE.CylinderGeometry(0.05, 0.07, 0.18, 10), color: VASE, position: [0, 0.09, 0] },
      // three thin stems fanned outward
      { geometry: new THREE.CylinderGeometry(0.006, 0.006, 0.16, 5), color: STEM, position: [0, 0.24, 0] },
      { geometry: new THREE.CylinderGeometry(0.006, 0.006, 0.15, 5), color: STEM, position: [0.035, 0.23, 0.01], rotation: [0, 0, -0.3] },
      { geometry: new THREE.CylinderGeometry(0.006, 0.006, 0.15, 5), color: STEM, position: [-0.035, 0.22, -0.01], rotation: [0.15, 0, 0.3] },
      // flower heads
      { geometry: new THREE.IcosahedronGeometry(0.028, 0), color: HEAD_A, position: [0, 0.33, 0] },
      { geometry: new THREE.IcosahedronGeometry(0.025, 0), color: HEAD_B, position: [0.06, 0.31, 0.015] },
      { geometry: new THREE.IcosahedronGeometry(0.025, 0), color: HEAD_C, position: [-0.06, 0.3, -0.02] },
    ];
  },
  animations: [],
});
